module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap-widget"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "cc-loader"
  }, [_c('div', {
    staticClass: "spinner"
  })]) : _c('div', [(!_vm.fetchError) ? _c('div', {
    staticClass: "widget-lastusers"
  }, [_c('div', {
    staticClass: "columns"
  }, _vm._l((_vm.users), function(user, index) {
    return _c('div', {
      staticClass: "user-item"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'user-profile',
          params: {
            id: user.id.value
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": user.picture.medium,
        "alt": user.name.first
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "user-name"
    }, [_vm._v("\n                            " + _vm._s(_vm._f("capitalize")(user.name.first)) + " " + _vm._s(_vm._f("upper")(user.name.last)) + "\n                        ")]), _vm._v(" "), _c('p', {
      staticClass: "user-date"
    }, [_vm._v("\n                            " + _vm._s(_vm._f("fromnow")(user.registered, 'fr')) + "\n                        ")])])], 1)
  }))]) : _c('div', {
    staticClass: "alert alert-error"
  }, [_vm._v("\n            " + _vm._s(_vm.fetchError) + "\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bb8bb8e6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/widget-lastusers.vue
// module id = 235
// module chunks = 0